import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from '../styles';

interface SavingProps {
	percentage?: number;
	months?: number;
}

export function Saving({ percentage = 0, months = 0 }: Readonly<SavingProps>) {
	return (
		<Row>
			<Col span={24}>
				<S.Title>{I18n.get('You will save')}</S.Title>
				<S.HighlightValue>{percentage}%</S.HighlightValue>
				<S.Title>{I18n.get('of your annual budget compared to your current approach.')}</S.Title>
			</Col>
			<Col span={24}>
				<S.Title>{I18n.get('This equals a savings equivalent to')}</S.Title>
				<S.HighlightValue>{months}</S.HighlightValue>
				<S.Title>{I18n.get('months of cost.')}</S.Title>
			</Col>
		</Row>
	);
}
